import axios from 'axios';

// file을 처리하는 형태 - 1: 1000(일반적으로 변경된), 0:1024(window의 크기))
const thresh = 1024;

// 현재 epoch 시간
export function nowEpoch() {
  return new Date().getTime() / 1000;
}

// 시간을 epoch시간으로 변환
export function epochFromDate(dateString) {
  const epoch = new Date(dateString).getTime() / 1000;
  if (isNaN(epoch)) {
    return '-';
  }
  if (epoch < 0) {
    return '-';
  }

  return epoch;
}

// epoch 시간을 utc 시간으로 변환
export function timeFormatFromUTCEpoch(epochUTC, formatType) {
  epochUTC = Number(epochUTC);
  if (!!!epochUTC) {
    return '-';
  }
  if (typeof formatType === 'undefined') {
    formatType = 1;
  }

  const d = new Date(0); // The 0 there is the key, which sets the date to the epoch
  d.setUTCSeconds(epochUTC);

  const yyyy = d.getFullYear();
  const MM = d.getMonth() + 1;
  const dd = d.getDate();
  const hh = d.getHours();
  const mm = d.getMinutes();
  const ss = d.getSeconds();

  if (localStorage.getItem('language') === 'en') {
    if (formatType === 1) {
      return (
        fitTwoDigit(MM) +
        '/' +
        fitTwoDigit(dd) +
        '/' +
        yyyy +
        ' ' +
        fitTwoDigit(hh) +
        ':' +
        fitTwoDigit(mm) +
        ':' +
        fitTwoDigit(ss)
      );
    } else if (formatType === 2) {
      return fitTwoDigit(MM) + '/' + fitTwoDigit(dd) + '/' + yyyy + ' ' + fitTwoDigit(hh) + ':' + fitTwoDigit(mm);
    } else if (formatType === 3) {
      return fitTwoDigit(MM) + '/' + fitTwoDigit(dd) + '/' + yyyy;
    } else if (formatType === 10) {
      return fitTwoDigit(hh) + ':' + fitTwoDigit(mm) + ':' + fitTwoDigit(ss);
    } else {
      //
    }
  } else {
    if (formatType === 1) {
      return (
        yyyy +
        '-' +
        fitTwoDigit(MM) +
        '-' +
        fitTwoDigit(dd) +
        ' ' +
        fitTwoDigit(hh) +
        ':' +
        fitTwoDigit(mm) +
        ':' +
        fitTwoDigit(ss)
      );
    } else if (formatType === 2) {
      return yyyy + '-' + fitTwoDigit(MM) + '-' + fitTwoDigit(dd) + ' ' + fitTwoDigit(hh) + ':' + fitTwoDigit(mm);
    } else if (formatType === 3) {
      return yyyy + '-' + fitTwoDigit(MM) + '-' + fitTwoDigit(dd);
    } else if (formatType === 4) {
      return yyyy + '-' + fitTwoDigit(MM);
    } else if (formatType === 10) {
      return fitTwoDigit(hh) + ':' + fitTwoDigit(mm) + ':' + fitTwoDigit(ss);
    } else {
      //
    }
  }

  return false;
}

export function utcTimeFormatFromUtcEpoch(epochUTC, formatType) {
  epochUTC = Number(epochUTC);
  if (!!!epochUTC) {
    return '-';
  }
  if (typeof formatType === 'undefined') {
    formatType = 1;
  }

  const d = new Date(0); // The 0 there is the key, which sets the date to the epoch
  d.setUTCSeconds(epochUTC);

  const yyyy = d.getUTCFullYear();
  const MM = d.getUTCMonth() + 1;
  const dd = d.getUTCDate();
  const hh = d.getUTCHours();
  const mm = d.getUTCMinutes();
  const ss = d.getUTCSeconds();

  if (formatType === 1) {
    return (
      yyyy +
      '-' +
      fitTwoDigit(MM) +
      '-' +
      fitTwoDigit(dd) +
      ' ' +
      fitTwoDigit(hh) +
      ':' +
      fitTwoDigit(mm) +
      ':' +
      fitTwoDigit(ss)
    );
  } else if (formatType === 2) {
    return yyyy + '-' + fitTwoDigit(MM) + '-' + fitTwoDigit(dd) + ' ' + fitTwoDigit(hh) + ':' + fitTwoDigit(mm);
  } else if (formatType === 3) {
    return yyyy + '-' + fitTwoDigit(MM) + '-' + fitTwoDigit(dd);
  }

  return false;
}

export function fitTwoDigit(n) {
  return n < 10 ? '0' + n : n;
}

//시간차이로 보기
export function timeDiffFromUTCEpoch(epochUTC) {
  if (epochUTC === '' || epochUTC === 0) {
    return '-';
  }
  const inputEpoch = parseInt(epochUTC) * 1000;
  const nowEpoch = new Date().getTime();
  let diff = '';
  const absDiff = parseInt(Math.abs(nowEpoch - inputEpoch) / 1000);

  const timeEncode = {
    ko: {
      sec: '초',
      min: '분',
      hour: '시간',
      day: '일',
      month: '개월',
      year: '년',
      now: '지금'
    },
    ja: {
      sec: '秒',
      min: '分',
      hour: '時間',
      day: '日',
      month: 'ヶ月',
      year: '年',
      now: '現在'
    },
    en: {
      sec: 'sec',
      min: 'min',
      hour: 'hour',
      day: 'days',
      month: 'month',
      year: 'year',
      now: 'now'
    }
  };
  const lang = timeEncode[localStorage.getItem('language')];

  if (absDiff !== 0) {
    if (absDiff < 61) {
      // 초단위 차이로 처리
      diff = absDiff + lang['sec'];
    } else if (absDiff < 3601) {
      // 분단위 차이
      diff = parseInt(absDiff / 60) + lang['min'];
    } else if (absDiff < 86401) {
      // 시간단위 차이
      diff = parseInt(absDiff / 3600) + lang['hour'];
    } else if (absDiff < 2592001) {
      // 일단위 차이
      diff = parseInt(absDiff / 86400) + lang['day'];
    } else if (absDiff < 31536001) {
      // 월단위 차이
      diff = parseInt(absDiff / 2592000) + lang['month'];
    } else {
      diff = parseInt(absDiff / 31536000) + lang['year'];
    }
  } else {
    // 지금
    diff = lang['now'];
  }
  return diff;
}

// 초 단위 시간 변환
export function timeDiffFromSeconds(seconds) {
  if (seconds === '' || seconds === 0) {
    return '-';
  }

  const timeEncode = {
    ko: {
      sec: '초',
      min: '분',
      hour: '시간',
      day: '일',
      month: '개월',
      year: '년',
      now: '지금'
    },
    ja: {
      sec: '秒',
      min: '分',
      hour: '時間',
      day: '日',
      month: 'ヶ月',
      year: '年',
      now: '現在'
    },
    en: {
      sec: 'sec',
      min: 'min',
      hour: 'hour',
      day: 'days',
      month: 'month',
      year: 'year',
      now: 'now'
    }
  };

  const diff = [];
  const lang = timeEncode[localStorage.getItem('language')];

  if (seconds !== 0) {
    const hour = parseInt(seconds / 3600);
    const min = parseInt((seconds % 3600) / 60);
    const sec = seconds % 60;

    if (hour > 0) {
      diff.push(hour + lang['hour']);
    }

    if (min > 0) {
      diff.push(min + lang['min']);
    }

    if (sec > 0) {
      diff.push(sec + lang['sec']);
    }

    // diff = hour + lang['hour'] + ' ' + min + lang['min'] + ' ' + sec + lang['sec'];
  }

  return diff.join(' ');
}

// [{},{}] 구조에서 followOrder 적용 배열 리턴
export const getFollowOrderArray = (data, mainKey, orderKey) => {
  if (typeof data !== 'object' || typeof mainKey === 'undefined' || typeof orderKey === 'undefined') {
    return [];
  }

  const orderArray = [];
  const orderMapper = {};
  const orderParameter = {};
  const reverseMapper = {};
  for (let i = 0; i < data.length; i++) {
    const obj = data[i];
    orderParameter[obj.parameter] = i;
    reverseMapper[obj[orderKey]] = obj.parameter;
    if (obj[orderKey] === '') {
      orderArray.push(i);
      continue;
    }
    orderMapper[obj[orderKey]] = i;
  }

  // followOrder 가 공백이 아닌것으로 시작하는 경우
  if (orderArray.length === 0) {
    for (const parameter in orderMapper) {
      if (orderMapper.hasOwnProperty(parameter)) {
        if (typeof orderParameter[parameter] === 'undefined') {
          orderArray.push(orderParameter[reverseMapper[parameter]]);
          delete orderMapper[parameter];
          break;
        }
      }
    }
  }

  let orderArraySize = 0;
  while (orderArraySize !== orderArray.length) {
    orderArraySize = orderArray.length;
    const nextOrderKey = data[orderArray[orderArraySize - 1]][mainKey];
    if (nextOrderKey in orderMapper && orderMapper[nextOrderKey] !== 'undefined') {
      orderArray.push(orderMapper[nextOrderKey]);
    }
  }

  if (data.length !== orderArray.length) {
    return [];
  }

  return orderArray;
};

// Object를 key로 정렬
// type: 'number'
// 문자열일경우 숫자, 한글, 영문, 일본어의 순서대로 정렬한다.
export function sortObjectByKey(obj, type) {
  let keys = [];
  const KeyNumbers = [];
  const KeyHanguls = [];
  const KeyEnglishs = [];
  const KeyJapanese = [];

  const sortedObj = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      // 숫자형 Object
      if (type === 'number') {
        keys.push(key);
        // 문자형 Object
      } else {
        if (!isNaN(Number(key))) {
          KeyNumbers.push(key);
        } else if (!/[^ㄱ-ㅎㅏ-ㅣ가-힣 ]/i.test(key)) {
          KeyHanguls.push(key);
        } else if (!/[^a-zA-Z ]/i.test(key)) {
          KeyEnglishs.push(key);
        } else {
          KeyJapanese.push(key);
        }
      }
    }
  }

  if (type === 'number') {
    keys.sort((a, b) => {
      return a - b;
    });
  } else {
    KeyNumbers.sort((a, b) => {
      return a - b;
    });
    KeyHanguls.sort();
    KeyEnglishs.sort();
    KeyJapanese.sort();
    keys = KeyNumbers.concat(KeyHanguls, KeyEnglishs, KeyJapanese);
  }

  for (let i = 0, l = keys.length; l > i; i++) {
    sortedObj[keys[i]] = obj[keys[i]];
  }

  return sortedObj;
}

// 배열 중복 제거
export const ArrayDuplicateRemove = arrArg => {
  return arrArg.filter((elem, pos, arr) => {
    return arr.indexOf(elem) == pos;
  });
};

// 배열 정렬
export const ArraySort = (array, type, inner) => {
  return array.sort((a, b) => {
    // 내림차순
    if (type && type === 'desc') {
      if (typeof inner !== 'undefined') {
        return b[inner] - a[inner];
      } else {
        return b - a;
      }

      // 오름차순
    } else {
      if (typeof inner !== 'undefined') {
        return a[inner] - b[inner];
      } else {
        return a - b;
      }
    }
  });
};

// axios 표준 템플릿
export const requestRaw = (url, params, method) => {
  params = params || {};
  const lowerMethod = method.toLowerCase();
  let dataType = 'params';

  if (lowerMethod === 'post' || lowerMethod === 'put') {
    dataType = 'data';
  }

  return axios({
    method: method,
    url: url,
    [dataType]: params
  });
};

// 파일 사이즈 변환
export const fileSizeTrans = (size, decimal) => {
  size = Number(size);
  if (size === 0) {
    return { common: '0B', size: '0', unit: 'B' };
  }

  decimal = typeof decimal !== 'undefined' ? decimal : 0;
  // const s = thresh === 1000
  //   ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  //   : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  const s = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const e = Math.floor(Math.log(size) / Math.log(thresh));

  return {
    common: (size / Math.pow(thresh, e)).toFixed(decimal) + s[e],
    size: (size / Math.pow(thresh, e)).toFixed(decimal),
    unit: s[e]
  };
};

// 숫자 사이즈 변환
export const numberSizeTrans = (size, decimal) => {
  size = Number(size);
  if (size === 0) {
    return { common: '0', size: '0', unit: '' };
  }

  decimal = typeof decimal !== 'undefined' ? decimal : 0;
  const s = ['', 'K', 'M', 'B', 'T'];
  const e = Math.floor(Math.log(size) / Math.log(1000));

  return {
    common: (size / Math.pow(1000, e)).toFixed(decimal) + s[e],
    size: (size / Math.pow(1000, e)).toFixed(decimal),
    unit: s[e]
  };
};

export const humanFileSize = bytes => {
  if (Math.abs(bytes) < thresh) {
    return bytes + ' B';
  }

  // const units = thresh === 1000
  //   ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  //   : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  const units = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  let u = -1;
  do {
    bytes /= thresh;
    ++u;
  } while (Math.abs(bytes) >= thresh && u < units.length - 1);

  return bytes.toFixed(1) + ' ' + units[u];
};

export const commaNumber = number => {
  return number.toString().replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
};

// findIndex 처리
export const findIndex = (array, predicateFunction) => {
  const length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  let index = -1;
  for (let i = 0; i < array.length; ++i) {
    if (predicateFunction(array[i])) {
      index = i;
      break;
    }
  }
  return index;
};



// WEBPACK FOOTER //
// ./src/script/libs/commonFunc.js